import { render, staticRenderFns } from "./PaymentReturnHoldModal.vue?vue&type=template&id=5bd1deae"
import script from "./PaymentReturnHoldModal.vue?vue&type=script&lang=js"
export * from "./PaymentReturnHoldModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports